/* eslint-disable no-undef */
import { CommonObject, IObject } from '@common/typings/global';
import $axios from './config';
import { IAES } from '@common/utils/EAS';
import { getQueryString } from '@common/utils/common';
import { getCookie } from '@common/stores/cookie';
import { msSessionStorage } from '@common/utils/cache';
import { useBaseStore } from '@common/stores/storage';
import { customHeaderConfig } from '@common/axios/header';
export interface ISettings {
  aes?: IAES;
  apiKey?: string;
  loadTitle?: string; // loadin title
  hasLoad?: boolean; // 是否显示 loading
  errDialog?: boolean; // 如果code不为0，且不在无需处理的异常code当中, 弹出 error message
  ignoreError?: boolean; // 是否忽略所有异常
  ignoreErrorCodeList?: string[]; // code 白名单
  ignoreErrorCode?: boolean; // 忽略所以的 error code ， 不包括 网络error、token error
  ignoreBizErrorCode?: boolean; // 忽略业务错误信息
  ignoreToken?: boolean; // 忽略 tokne
  token?: string; // 传入的 vtoken
  errorCodeInfo?: {
    // systemError: 系统错误
    // defaultError: 默认错误，当code 不为 0 同时内置的系统错误都没有触发的时候
    [code: string | number | 'systemError' | 'defalutError']: (data?: IResponse<any>) => void;
  };
  errorRedirectUrlInfo?: {
    // default 默认重定向url，配置了default 没有配置其他的 url ，所有错误都会跳转到这个 url
    // unlogin 为登录的重定向 url， 未登录的错误，跳转到这个 url
    // networkError 为网络请求错误的重定向 url，
    // commonError 系统错误的 url
    [key in 'default' | 'unLogin' | 'networkError' | 'commonError']?: {
      type: 'replace' | 'href';
      url?: string;
    };
  };
  timeout?: number; // 根据配置获取超时时间
  isUnLoginRequest?: boolean;
  type?: string;
}

interface AxiosResponse {
  data: IResponse;
}

window.ERR_DIALOG = null;

type RequestParamsInfo = {
  url: string;
  method: 'post' | 'get';
  params?: any;
  options?: ISettings & {
    requestTime?: number;
    timeout?: number;
    timeoutWhiteList?: any;
  };
  headers: any;
};

type RequestResponseParamsInfo = RequestParamsInfo & {
  response?: AxiosResponse;
};

type RequestErrorParamsInfo = RequestParamsInfo & {
  error?: any;
};

export function requestUtil() {
  // 请求前回调
  let onBeforeRequestCallBack: ((params: RequestParamsInfo) => void) | undefined = undefined;
  // 请求后回调
  let onAfterRequesttCallBack: ((params: RequestResponseParamsInfo) => void) | undefined =
    undefined;
  // 请求出现错误回调
  let onRequestErrortCallBack: ((params: RequestErrorParamsInfo) => void) | undefined = undefined;
  // 请求回调成功， 但后端没有正常返回值
  let onResponseCallBack:
    | ((params: RequestResponseParamsInfo) => IResponse<any> | null)
    | undefined = undefined;

  let encodeUrl: string[] = [];

  function init(params: {
    onBeforeRequest?: (params: RequestParamsInfo) => void;
    onAfterRequest?: (params: RequestResponseParamsInfo) => void;
    onRequestError?: (params: RequestErrorParamsInfo) => void;
    onResponse?: (params: RequestResponseParamsInfo) => IResponse<any> | null;
  }) {
    onBeforeRequestCallBack = params.onBeforeRequest;
    onAfterRequesttCallBack = params.onAfterRequest;
    onRequestErrortCallBack = params.onRequestError;
    onResponseCallBack = params.onResponse;
  }

  function clear() {
    onBeforeRequestCallBack = undefined;
    onAfterRequesttCallBack = undefined;
    onRequestErrortCallBack = undefined;
    onResponseCallBack = undefined;
  }

  function onBeforeRequest(hold: (params: RequestParamsInfo) => void) {
    onBeforeRequestCallBack = hold;
  }

  function onAfterRequest(hold: (params: RequestResponseParamsInfo) => void) {
    onAfterRequesttCallBack = hold;
  }

  function onRequestError(hold: (params: RequestErrorParamsInfo) => void) {
    onRequestErrortCallBack = hold;
  }

  function onResponse(hold: (params: RequestResponseParamsInfo) => IResponse<any> | null) {
    onResponseCallBack = hold;
  }

  function encodeUrlList(list: string[]) {
    encodeUrl = list;
  }

  function initHeaders(url: string, options: ISettings, oldHeaders?: Record<string, any>) {
    const { appKey, productCode, processId } = useBaseStore();

    const headers = {
      ...oldHeaders,
      ...customHeaderConfig(appKey),
    };
    if (options.aes) {
      headers['X-Sk-Trans'] = options.aes?.encrypted || '';
      headers['X-EncryKey-V'] = 'SYS_COMMWEB_V2';
    }
    if (!options.ignoreToken) {
      if (options.token) {
        headers['X-VToken'] = options.token;
      } else {
        const token = getQueryString('vtoken') || getCookie('vtoken');
        if (token && token !== 'undefined' && token !== 'null') {
          headers['X-VToken'] = token;
        } else {
          delete headers['X-VToken'];
        }
      }
    } else {
      delete headers['X-VToken'];
    }

    headers['X-Product-Code'] = productCode || '5105';
    if (
      !productCode &&
      location.pathname.indexOf('ncredit') === 1 &&
      ['SYH_IOS', 'SYH_ANDROID'].includes(appKey)
    ) {
      headers['X-Product-Code'] = '5105';
    }

    headers['X-Application-Id'] =
      headers?.['Provacy-Application-Id'] || (options.isUnLoginRequest ? 'ayhdl' : appKey);
    // 设置进程id
    if (processId) {
      headers['X-Period-AccessId'] = processId;
    }

    if (encodeUrl.includes(url)) {
      headers['MS-ENCODE-PATH'] = true;
    }
    return headers;
  }

  async function post(
    url: string,
    params: any,
    options: ISettings = {},
    headers?: Record<string, any>,
  ) {
    const requestHeaders = initHeaders(url, options, headers);
    const requestOptions = {
      hasLoad: true,
      errDialog: true,
      ...options,
    };
    onBeforeRequestCallBack &&
      onBeforeRequestCallBack({
        url: url,
        method: 'post',
        params: params,
        options: requestOptions,
        headers: requestHeaders,
      });
    try {
      let urlTool = $axios;
      if (
        window.$axios &&
        (location.hostname.includes('localhost') ||
          location.hostname === '127.0.0.1' ||
          location.hostname.includes('test'))
      ) {
        urlTool = window.$axios;
      }
      const res: AxiosResponse = await urlTool.post(url, params, {
        headers: requestHeaders,
        timeout: requestOptions.timeout,
      });
      onAfterRequesttCallBack &&
        onAfterRequesttCallBack({
          url: url,
          method: 'post',
          params: params,
          options: requestOptions,
          headers: requestHeaders,
          response: res,
        });
      if (onResponseCallBack) {
        return onResponseCallBack({
          url: url,
          method: 'post',
          params: params,
          options: requestOptions,
          headers: requestHeaders,
          response: res,
        });
      }
      return res.data;
    } catch (e) {
      onRequestErrortCallBack &&
        onRequestErrortCallBack({
          url: url,
          method: 'post',
          params: params,
          options: requestOptions,
          headers: requestHeaders,
          error: e,
        });
      return null;
    }
  }

  async function get(
    url: string,
    params?: { [x: string]: any },
    options: ISettings = {},
    headers?: Record<string, any>,
  ) {
    const requestOptions = {
      hasLoad: true,
      errDialog: true,
      ...options,
    };
    const finalParams = formatParams(params);
    const requestHeaders = initHeaders(url, options, headers);
    onBeforeRequestCallBack &&
      onBeforeRequestCallBack({
        url: url,
        method: 'get',
        params: params,
        options: requestOptions,
        headers: requestHeaders,
      });
    let urlTool = $axios;
    if (
      window.$axios &&
      (location.hostname.includes('localhost') ||
        location.hostname === '127.0.0.1' ||
        location.hostname.includes('test'))
    ) {
      urlTool = window.$axios;
    }
    try {
      const res: IResponse = await urlTool.get(url, {
        params: finalParams,
        headers: requestHeaders,
        timeout: requestOptions.timeout,
      });
      onAfterRequesttCallBack &&
        onAfterRequesttCallBack({
          url: url,
          method: 'get',
          params: params,
          options: requestOptions,
          headers: headers,
          response: res,
        });
      if (onResponseCallBack) {
        return onResponseCallBack({
          url: url,
          method: 'get',
          params: params,
          options: requestOptions,
          headers: headers,
          response: res,
        });
      }
      return res.data;
    } catch (e) {
      onRequestErrortCallBack &&
        onRequestErrortCallBack({
          url: url,
          method: 'get',
          params: params,
          options: requestOptions,
          headers: headers,
          error: e,
        });
      return null;
    }
  }

  // Adapte Response
  // function adaptorResponse(responseDate: IResponse, options?: ISettings) {
  //   if (responseDate.code === SUCCESS_CODE || options?.ignoreError) {
  //     // 如果配置no code
  //     return responseDate;
  //   }
  //   // 如果某个业务有单独定制白名单code，则放行操作，直接向上抛出
  //   if (options?.ignoreErrorCodeList && options?.ignoreErrorCodeList.includes(responseDate.code)) {
  //     return responseDate;
  //   }
  //   // 如果code不为0，且不在无需处理的异常code当中
  //   if (!bizErrorCodeMap.get(responseDate.code) && options?.errDialog) {
  //     errToast(responseDate.message);
  //     return null;
  //   }
  //   if (options?.ignoreBizError || !bizErrorCodeMap.get(responseDate.code)) {
  //     return responseDate;
  //   }
  //   // 如果是业务异常
  //   const customResponse = {
  //     code: responseDate.code || -1,
  //     parsedMsg: { message: '', code: '' },
  //   };
  //   // 这里也可以用前端的异常message
  //   customResponse.parsedMsg.message = responseDate.message;
  //   customResponse.parsedMsg.code = responseDate.code;
  //   // 后端可能会包裹一层msg：例如： "message": "{\"msg\":\"尊敬的巴拉巴拉一大堆\",\"title\":\"失败\"}",
  //   // 也可能例如： "{"msg":"尊敬的巴拉巴拉一大堆","title":"失败"}"
  //   const msgStrReg = /\\"msg\\"/;
  //   const msgStrEscapeReg = /"msg"/;
  //   if (msgStrReg.test(responseDate.message) || msgStrEscapeReg.test(responseDate.message)) {
  //     customResponse.parsedMsg.message = JSON.parse(responseDate.message)?.msg || '';
  //   }
  //   return {
  //     ...responseDate,
  //     ...customResponse,
  //   };
  // }

  // function errToast(message: string) {
  //   msToast.error({
  //     message,
  //     duration: 2000,
  //   });
  // }

  // 去空字符串处理
  function formatParams(params: CommonObject = {}) {
    const result: IObject = {};
    for (const key in params) {
      if (params[key] !== '') {
        result[key] = params[key];
      }
    }
    return result;
  }

  window.$axios = $axios;

  return {
    init,
    clear,
    post,
    get,
    onRequestFailed: onResponse,
    onBeforeRequest,
    onAfterRequest,
    onRequestError,
    encodeUrlList,
  };
}

export default requestUtil();
